const andpad_json_data = {
    "parking_requests": [
        {
            "parking_request_id": null,
            "estimates": []
        }
    ]
} 

const andpad_json_data_estimate = {
    "deleted": false,
    "parking_estimate_id": null,
    "parking_start_date": null,
    "parking_end_date": null,
    "changed_parking_start_date": null,
    "changed_parking_end_date": null,
    "parking_name": null,
    "latitude": null,
    "longitude": null,
    "prefecture_code": null,
    "city": null,
    "street": null,
    "layout_file_deleted":  false,
    "layout_file": {
        "content": null,
        "file_name": null
    },
    "invoice_file_deleted":  true,
    "invoice_file": {
        "content": null,
        "file_name": null
    }

}


export {andpad_json_data, andpad_json_data_estimate}